import { addDays } from 'date-fns';

import { Announcement, AnnouncementItem } from './types';

const startingDate = new Date('2025-01-15T16:00:00+01:00');

export const items: AnnouncementItem[] = [
  {
    key: 'faJan15Features',
    title: 'Discover the new Kittl 🔥',
    description:
      'Real-time collaboration, professional tools and so much more.',
    image: 'https://static.kittl.com/Kittl%20Announcement%20Popup.png',
    buttonText: 'Read Full Article',
    link: '/article/kittls-next-chapter-2025',
  },
];

export const announcement: Announcement = {
  // We save all previous values here to not duplicate them accidentally
  // id: 'faMasksAndBGRemoval',
  // id: 'faKittlAiReleased',
  // id: 'faMockupGenerator',
  // id: 'faCroppingBGLibraryObjectShad',
  // id: 'faBackgroundGeneratorV1',
  // id: 'faAiFeed',
  // id: 'faAiQuotes',
  // id: 'faPrint',
  // id: 'AiX1',
  // id: 'faDialyCreditLimit',
  // id: 'faInfiniteCanvas',
  // id: 'faEraser',
  // id: 'faInfiniteCanvasV2',
  id: 'faJan15Features',
  starts: startingDate,
  ends: addDays(startingDate, 10),
  visibleFor: 'existingUsers',
  items: items,
};
